import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import { css } from 'aphrodite'

import { Image } from './Image'
import { Text } from './Text'
import * as assets from '../assets'
import { Menu } from 'semantic-ui-react'
import createStyles from './styles'

export class HeaderLayout extends React.Component {
  state = {
    banner: null,
  }

  setBanner = (text, target) => this.setState({ banner: { text, target } })
  clearBanner = () => this.setState({ banner: null })

  getChildContext() {
    return { setBanner: this.setBanner }
  }

  render() {
    const styles = getStyles(this.props, this.context)
    const { children, ...props } = this.props

    return (
      <div className={css(styles.root)}>
        <Menu stackable secondary className={css(styles.responsiveNav)}>
          <Menu.Item>
            <Link to="/">
              <Image source={assets.fullLogo} width={175} />
            </Link>
          </Menu.Item>

          <Menu.Menu position="right">
            <Menu.Item>
              <Link
                to="/identity_validation"
                className={css(styles.navigationItem)}
              >
                <i className="id badge icon" /> Verify Identity
              </Link>
            </Menu.Item>

            <Menu.Item>
              <Link to="/settings" className={css(styles.navigationItem)}>
                <i className="settings icon" /> Settings
              </Link>
            </Menu.Item>

            <Menu.Item>
              <Link
                to="https://coincart.co/privacy"
                target="_blank"
                className={css(styles.navigationItem)}
              >
                <i className="privacy icon" /> Privacy
              </Link>
            </Menu.Item>

            <Menu.Item>
              <Link to="/logout" className={css(styles.navigationItem)}>
                <i className="log out icon" /> Log Out
              </Link>
            </Menu.Item>
          </Menu.Menu>
        </Menu>

        {this.state.banner && (
          <div className={css(styles.banner)}>
            {this.state.banner.target ? (
              <Link to={this.state.banner.target}>
                <Text color="foreground" size="huge">
                  {this.state.banner.text}
                </Text>
              </Link>
            ) : (
              <Text color="foreground" size="huge">
                {this.state.banner.text}
              </Text>
            )}
          </div>
        )}

        <div className={css(styles.main)}>
          {React.cloneElement(children, props)}
        </div>
      </div>
    )
  }
}

HeaderLayout.childContextTypes = {
  setBanner: PropTypes.func,
}

HeaderLayout.contextTypes = {
  theme: PropTypes.object,
}

const getStyles = createStyles((props, context, theme) => ({
  root: {
    backgroundColor: theme.colors.background,
    height: '100%',
    position: 'relative',
    width: '100%',
  },

  header: {
    alignItems: 'center',
    backgroundColor: theme.colors.foreground,
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.1)',
    display: 'flex',
    height: 68,
    justifyContent: 'center',
    left: 0,
    position: 'fixed',
    right: 0,
    top: 0,
    width: '100%',
    zIndex: 9999,
  },

  headerContent: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: 940,
    width: '100%',
  },

  navigation: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    listStyle: 'none',
  },

  navigationItem: {
    color: theme.colors.primary,
    marginRight: 20,
    fontSize: 16,
  },

  banner: {
    background: '#2DCC70',
    padding: '10px 0',
    textAlign: 'center',
  },

  main: {
    padding: 10,
    marginTop: 60,
  },

  responsiveNav: {
    background: theme.colors.foreground,
    boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.1)',
  },
}))



// WEBPACK FOOTER //
// ./src/components/HeaderLayout.js